import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  paper: {
    width: '100%',
    height: '100%',
    position: 'relative',
    textAlign: 'center',
    padding: theme.spacing.unit
  },
  header: {
    margin: theme.spacing.unit*2
  }
})

class Parse extends React.Component {

  state = {}

  render() {
    const { classes } = this.props
    return (
      <Paper className={classes.paper} elevation={1}>
        <Typography gutterBottom variant='headline' color='secondary' className={classes.header}>
          Parse
        </Typography>
        <Typography>
          We are in the process of upgrading Addresscloud Admin.  This page is under development, for more
          information or to log a request please contact <a href='mailto:support@addresscloud.com'>support@addresscloud.com</a>.
        </Typography>
      </Paper>
    )
  }
}

Parse.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Parse)
